<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑工艺' : '新增工艺'"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div>
        <div v-if="loaded">
          <div class="mu-ban-category">
            <div>
              <span class="m-r-5 c-black">关联类目</span>
            </div>
            <div class="flex-1 m-r-10">
              <b-goods-texture
                :data.sync="categoryTextureData"
                :bao_han="['加工']"
                :isLoadTexture="false"
              />
            </div>
          </div>
          <e-form ref="refForm" :column="formColumn" :data.sync="selfData" />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-绑定设备 -->
    <PopupBindSheBei
      v-if="isShowPopupBindSheBei"
      :show.sync="isShowPopupBindSheBei"
      :list="selfData.she_bei_list"
      @success="popupBindSheBeiSuccess"
    />

    <!-- 弹窗-绑定工序 -->
    <PopupBindGongXu
      v-if="isShowPopupBindGongXu"
      :show.sync="isShowPopupBindGongXu"
      :list="selfData.gong_xu_list"
      @success="popupBindGongXuSuccess"
    />
  </div>
</template>

<script>
import PopupBindSheBei from './popup-bind-she-bei'
import PopupBindGongXu from './popup-bind-gong-xu'
export default {
  components: {
    PopupBindSheBei,
    PopupBindGongXu
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      categoryTextureData: {
        category_list: []
      },
      selfData: {
        id: '',
        category_list: [],
        category_ids: [],
        category_str: '',
        code: '',
        mu_ban_ming_cheng: '',
        she_bei_list: [],
        gong_xu_list: [],
        gong_yi_bei_zhu: '',
        fu_jia_can_shu_list: [],
        status: true
      },
      groupList: [],
      formColumn: [
        {
          type: 'text',
          title: '工艺编码',
          field: 'code',
          disabled: true,
          placeholder: '自动生成'
        },
        {
          type: 'text',
          title: '工艺名称',
          field: 'mu_ban_ming_cheng'
        },
        {
          type: 'button',
          title: '关联设备',
          placeholder: '绑定',
          icon: 'vxe-icon-link',
          isError: true,
          fnChange: () => {
            this.isShowPopupBindSheBei = true
          }
        },
        {
          type: 'button',
          title: '绑定工序',
          placeholder: '绑定',
          icon: 'vxe-icon-link',
          isError: true,
          fnChange: () => {
            this.isShowPopupBindGongXu = true
          }
        },
        {
          type: 'textarea',
          title: '工艺描述',
          field: 'gong_yi_bei_zhu',
          width: '100%'
        },
        {
          type: 'upload_file',
          title: '附件文档',
          field: 'fu_jia_can_shu_list'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      isShowPopupBindSheBei: false,
      isShowPopupBindGongXu: false
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    selfData: {
      handler(val) {
        this.formColumn.forEach((item) => {
          if (item.title.includes('关联设备')) {
            let len = val.she_bei_list.length
            item.isError = !len
            item.placeholder = `绑定(${len})`
          }
          if (item.title.includes('绑定工序')) {
            let len = val.gong_xu_list.length
            item.isError = !len
            item.placeholder = `绑定(${len})`
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.initSelfData()
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/gongyi/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
          this.categoryTextureData.category_list = this.$util.deepCopy(result.category_list)
        }
      })
      this.loaded = true
    },
    // 初始化数据
    initSelfData() {
      this.loaded = false
      this.loaded = true
    },
    // 弹窗-绑定设备-成功
    popupBindSheBeiSuccess(data) {
      this.selfData.she_bei_list = data
    },
    // 弹窗-绑定工序-成功
    popupBindGongXuSuccess(data) {
      this.selfData.gong_xu_list = data
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let category_list = this.$util.deepCopy(this.categoryTextureData.category_list)
      this.selfData.category_ids = category_list.map((item) => item.id)
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/saveOrUpdate',
        data: {
          form_data: this.$util.deepCopy(this.selfData)
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.mu-ban-category {
  position: relative;
  z-index: 99;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}
</style>
